import { api } from 'api';
import { AxiosPromise } from 'axios';
import { User } from 'features/user/ts';
import { UserRole } from 'features/user/ts/UserRole';
import { CreatePartnerUser } from 'features/users/ts/CreatePartnerUser';
import { PartnerUser } from 'features/users/ts/PartnerUser';
import { BalanceCurrency } from 'features/app/ts/BalanceCurrency';
import { ShareBalance } from 'features/users/ts/ShareBalance';
import { IdType } from 'ts/IdType';

export const setIsUserActiveRequest = (id: IdType, is_active: boolean) =>
  api.patch(`/partners/partner-users/${id}/edit/`, { is_active });

export const deleteUserRequest = (id: IdType) => api.delete(`/partners/partner-users/${id}/`);

export const getRolesRequest = (): AxiosPromise<UserRole[]> => api.get(`/partners/roles/`);

export const createUserRequest = (userInput: CreatePartnerUser): AxiosPromise<User> =>
  api.post(`/partners/partner-users/create/`, userInput);

export const editUserProfileRequest = (id: IdType, user: Omit<PartnerUser, 'id'>): AxiosPromise<PartnerUser> => {
  return api.patch(`/partners/partner-users/${id}/edit/`, user);
};

export const getBalanceByUserRequest = (id: number): AxiosPromise<BalanceCurrency[]> =>
  api.get(`/partners/check-user-balance/${id}/`);

export const shareBalanceRequest = (balance: ShareBalance) => api.post(`/partners/transfer-balance/`, balance);
